import { CrudService } from '@/services/crudService';

function resolveNaaviBaseUrl() {
  if (process.env.NODE_ENV === 'development') {
    return '/naavi';
  }
  const envUrl = process.env.VUE_APP_NAAVI_URL;
  if (envUrl && envUrl.length) {
    return envUrl;
  }
  return '/naavi';
}

const naaviCrud = new CrudService({
  baseUrl: resolveNaaviBaseUrl(),
  allowAuth: true,
  handleUnauthorized: false,
  // naavi es otro origen y usa Bearer, no la cookie de sesión: no mandar X-Auth-Audience
  // (evita un preflight CORS por una cabecera no permitida allí).
  audience: null,
});

export function getNaaviCrud() {
  return naaviCrud;
}
